
import PropTypes from 'prop-types'
import React from 'react'
import { addSpaceReact as addSpace } from 'lib/utils'
import RunEvent from './run-event'

const RunEventList = props => {
  const { events, label, type } = props
  let { name } = props

  if (events.length) {
    let list = []

    events.forEach(function (event) {
      // HACK(tejasmanohar): empty <RunEvent objectName.../> for sources
      if (event.collection || type === 'source') name = ''
      list.push(<RunEvent level={event.level} objectType={event.collection || type} objectName={name} response={event.message} />)
    })

    return (
      <div className='Run-EventList'>
        {list.reduce(addSpace(10), [])}
      </div>
    )
  }

  return (
    <div className='Run-noErrors'>
      There were no {label}
    </div>
  )
}

RunEventList.propTypes = {
  events: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string
}

RunEventList.displayName = 'RunEventList'

export default RunEventList



// WEBPACK FOOTER //
// ./ui/Run/run-event-list.js